import React from 'react';
import { Switch } from '@/components/ui/switch';
import { GripVertical } from 'lucide-react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

interface ColumnConfig {
  id: string;
  label: string;
  description: string;
  visible: boolean;
}

interface SortableColumnRowProps {
  column: ColumnConfig;
  onToggle: (id: string) => void;
  t: (key: string) => string;
}

export const SortableColumnRow = ({ column, onToggle, t }: SortableColumnRowProps) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: column.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="grid grid-cols-[1fr,2fr,auto] gap-4 px-2 items-center bg-background py-2 border-b last:border-0">
      <div className="font-medium">{t(column.label)}</div>
      <div className="text-sm text-muted-foreground">{t(column.description)}</div>
      <div className="flex items-center gap-2">
        <Switch checked={column.visible} onCheckedChange={() => onToggle(column.id)} />
        <div {...attributes} {...listeners} className="cursor-grab active:cursor-grabbing p-1 hover:bg-muted rounded">
          <GripVertical className="w-4 h-4 text-muted-foreground" />
        </div>
      </div>
    </div>
  );
};
